import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FlashCardModel } from 'src/app/api/models';
import { FlashCardStacksService } from 'src/app/api/services';

import { PrintFlashCardStackComponent } from '../../../widget/print-flash-card-stack/print-flash-card-stack.component';

@Component({
  selector: 'qa-cms-print-flash-card-stack',
  templateUrl: './cms-print-flash-card-stack.component.html',
  styleUrls: ['./cms-print-flash-card-stack.component.scss'],
  imports: [PrintFlashCardStackComponent],
})
export class CmsPrintFlashCardStackComponent {
  stack: FlashCardModel[];

  constructor(
    private api: FlashCardStacksService,
    private activeRoute: ActivatedRoute
  ) {
    this.activeRoute.params.subscribe((params) => {
      this.api
        .getCardsInFlashCardStack({ id: params.stackId })
        .subscribe((stack) => {
          this.stack = stack;
        });
    });
  }
}
